let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1L6rf")).then(() => parcelRequire('3FwQL'));